const ALLOWED_FILE_TYPES = [
    'image/gif',
    'image/jpeg',
    'image/png',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/pdf',
];

const ALLOWED_EXT = '.bmp,.gif,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx,.pdf';

const SELECT_OPTION = {
    en: 'Select One',
    es: 'Seleccione uno',
};

const MAX_FILE_SIZE_IN_MB = 5;

export const VERIFICATION = {
    NOT_VERIFIED_TEXT_ACTION_NEEDED: 'dmi.applicantVerifications.actionNeeded',
    NOT_VERIFIED_TEXT: 'dmi.applicantVerifications.notVerifiedLabel',
    VERIFIED_TEXT: 'dmi.applicantVerifications.verified',
    COMMUNITY_ENGAGEMENT_NOT_VERIFIED: 'dmi.applicantVerifications.communityEngagementNotVerified',
    STARTS_WITH: '--',
    ALLOWED_FILE_TYPES,
    ALLOWED_EXT,
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
    ZERO_DOLLARS: '$0',
    INCOME: 'Income',
    AMOUNT_INPUT_MIN_VALUE: -999000000,
    AMOUNT_INPUT_MAX_VALUE: 999000000,
    SELECT_OPTION,
    MAX_FILE_SIZE_IN_MB,
    ROP_EXPIRED: 'ROP_EXPIRED',
    NONE: 'NONE',
    VERIFIED: 'VERIFIED',
    NOT_VERIFIED: 'NOT_VERIFIED',
};

// HIX-227198: Program-specific Lawful Presence Verification statuses shown
export const LAWFUL_PRESENCE_VLP_STATUSES = [
    {
        statusKey: 'medicaidVlpStatus',
        labelId: 'dmi.applicantVerifications.medicaidVlpStatus',
    },
    {
        statusKey: 'aptcVlpStatus',
        labelId: 'dmi.applicantVerifications.aptcVlpStatus',
    },
    {
        statusKey: 'qhpVlpStatus',
        labelId: 'dmi.applicantVerifications.qhpVlpStatus',
    },
] as const;

export const VERIFICATION_TYPE = {
    DEATH: 'Death',
    SOCIAL_SECURITY_NUMBER: 'Social Security Number',
    NON_ESI_MINIMUM_ESSENTIAL_COVERAGE: 'Non-ESI Minimum Essential Coverage',
    // Map key must match documentCategoryStatusMap key from verificationResultDashboard byte-for-byte (EN label).
    COMMUNITY_ENGAGEMENT: 'Community Engagement',
};

// Maps the documentCategoryStatusMap key (human-readable, returned by the
// DMI verifications view) to the enum code expected by /ms-verification/api/auto-verify.
// Backend reference: verificationTypeMap on ms-verification.
export const VERIFICATION_TYPE_CODE: Record<string, string> = {
    'Social Security Number': 'SSN',
    'Citizenship': 'CITIZENSHIP',
    'Lawful Presence': 'LAWFUL_PRESENCE',
    'Death': 'DEATH',
    'Incarceration Status': 'INCARCERATION',
    'Income': 'INCOME',
    'Residency': 'RESIDENCY',
    'Non-ESI Minimum Essential Coverage': 'NON_ESI_MEC',
    'Minimum Essential Coverage': 'ESI_MEC',
    'American Indian/Alaska Native Status': 'AIAN',
};
